import React,{ useState,useEffect,useContext } from 'react'
import { Box, styled, Typography,keyframes ,Button,Grid,Card,CardContent , TextField,FormControl,OutlinedInput,InputLabel,IconButton,Collapse} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import '@fontsource/montserrat';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import axios from 'axios';
import beACurator from '../assets/beACurator.svg'
import TickCircle from '../assets/tick-circle-solid.svg'
import HowCanJoin from '../assets/how_can_join.svg'
import starredBackground from '../assets/starredBackground.svg'
import PeopleListening from '../assets/PeopleListening.svg'
import { useSpring, animated } from '@react-spring/web'
import { useInView } from 'react-intersection-observer';
import { useNavigate,Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import '../css/hidescrollbar.css'
import ReactGA from "react-ga4";
import { UriContext } from '../pages/Main';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import CuratorPageBackground from '../assets/curator_page_background_image.svg'
import rightWing from '../assets/right_wing.svg'
import leftWing from '../assets/left_wing.svg'
import zIndex from '@mui/material/styles/zIndex';





const CuratorForm = () => {
    const [phone, setPhone] = useState('');
    const [ unsubscribed, setUnsubscribed ] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage ] = useState(null);
    const emptyForm = { name: '', email: '' }
    const [form, setForm] = useState(emptyForm);
    const [errors, setErrors] = useState({ name: false, email: false });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: false })); // reset error when typing
      };
    
    const validate = () => {
        const newErrors = {
            name: form.name.trim() === '',
            email: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email),
        };
        setErrors(newErrors);
        return !Object.values(newErrors).includes(true);
    };

    const handleSubmit = async (e) => {
            e.preventDefault();
            if (validate()) {
                try {
                    // const backend_host = localStorage.getItem('BACKEND_URL');
                    const backend_host = process.env.REACT_APP_BACKEND_URL
                    // const backend_host = "http://127.0.0.1:8000"
                    const user_id = process.env.REACT_APP_USER_ID;
                    await axios.post(`${backend_host}/curator/data`,
                        {
                            "name":form?.name,
                            "email":form?.email,
                            "phone_no":form?.phone_no
                        },
                        {
                            headers: {
                            'Authorization': user_id
                          }
                        },
                        
                    )
                        .then(response => {
                            if (response.status === 200) {
                                const { client_id,message } = response.data
                                setUnsubscribed(true);
                                setMessage(message);
                                setForm(emptyForm);
                                setTimeout(()=>{
                                    setMessage(null);
                                },10000)
                            }
                        })
                    .catch(error => {
                        console.error(error);
                        setError("Something went wrong, Please try again");
                        setTimeout(()=>{
                            setError(null);
                        },10000)
                    })
                } catch (err) {
                console.error(err);
                setError("Something went wrong, Please try again");
                setTimeout(()=>{
                        setError(null);
                    },10000)
                }
            }
        };
     return(
        <Box
            zIndex={100}
            id="CuratorForm"
            component="form"
            noValidate
            onSubmit={handleSubmit}
            color="white"
            paddingInline={4}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                maxWidth: '560px',
                width: '90vw',
                mx: 'auto',
                mt: 4,
            }}
            >
                {/* Name Field */}
                <Box>
                    <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="left"
                    sx={{
                        fontSize: '14px',
                        letterSpacing: '1%',
                        lineHeight: '24px',
                    }}
                    >
                    Name 
                    </Typography>
                    <TextField
                    autoComplete="off"
                    type="text"
                    fullWidth
                    required
                    placeholder="Eg. John Doe"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    sx={inputStyles(errors.name)}
                    />
                </Box>

                {/* Email Field */}
                <Box>
                    <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="left"
                    sx={{
                        fontSize: '14px',
                        letterSpacing: '1%',
                        lineHeight: '24px',
                    }}
                    >
                    Email 
                    {/* <span style={{ color: 'red' }}>*</span> */}
                    </Typography>
                    <TextField
                    autoComplete="off"
                    type="email"
                    fullWidth
                    required
                    placeholder="Eg. john@example.com"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    sx={inputStyles(errors.email)}
                    />
                </Box>

            {/* <Box sx={{ width: '100%' }}>
                <Typography
                    variant="body1"
                    gutterBottom
                    textAlign="left"
                    sx={{
                    fontSize: '14px',
                    letterSpacing: '1%',
                    lineHeight: '24px',
                    color: '#fff',
                    }}
                >
                    Mobile No. <span style={{ color: 'grey', fontStyle: 'italic' }}>(Optional)</span>
                </Typography> */}

                {/* Phone input wrapper */}
                {/* <Box
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    border: '1px solid #A670FF',
                    borderRadius: '10px',
                    overflow: 'visible', // very important to not clip dropdown
                    position: 'relative',
                    zIndex: 1,
                    backgroundColor: 'transparent',
                    height: '56px',
                    }}
                > */}
                    {/* Country code + flag selector */}
                    {/* <Box sx={{ width: '25%' }}>
                    <PhoneInput
                        country={'in'}
                        value={phone}
                        onChange={(value) => setPhone(value)}
                        enableSearch={true}
                        inputProps={{ name: 'phone' }}
                        placeholder=""
                        inputStyle={{
                        width: '100%',
                        height: '56px',
                        backgroundColor: 'transparent',
                        color: '#fff',
                        fontSize: '16px',
                        border: 'none',
                        borderRight: '1px solid #A670FF',
                        paddingLeft: '45px',
                        }}
                        buttonStyle={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        }}
                        containerStyle={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'transparent',
                        position: 'relative',
                        }}
                        dropdownStyle={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        zIndex: 9999,
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        width: '100%',
                        }}
                        disableCountryCode={false}
                        disableDropdown={false}
                        countryCodeEditable={false}
                        renderStringAsFlag={true}
                        localization={{ in: 'India', us: 'USA', gb: 'UK', fr: 'France' }} // shows readable names
                        autoFormat={false}
                        onlyCountries={['in', 'us', 'gb', 'fr', 'de', 'ca']}
                    />
                    </Box> */}

                    {/* User's phone number input */}
                    {/* <Box
                    component="input"
                    type="tel"
                    placeholder="Enter phone number"
                    sx={{
                        width: '75%',
                        height: '100%',
                        border: 'none',
                        outline: 'none',
                        padding: '0 12px',
                        fontSize: '16px',
                        backgroundColor: 'transparent',
                        color: '#fff',
                        '&::placeholder': {
                        color: '#aaa',
                        },
                    }}
                    />
                </Box>
                </Box> */}

                <Button
                variant="contained"
                type='submit'
                sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    maxWidth: '80%',
                    borderRadius: '25px',
                    alignSelf: 'center',
                    fontSize: '14px',
                    paddingInline:'40px',
                    paddingBlock:'10px',
                    textTransform: 'none', // disables UPPERCASE
                    boxShadow: 'none',
                    '&:hover': {
                    backgroundColor: '#f2f2f2',
                    boxShadow: '0 0 6px rgba(0,0,0,0.1)',
                    },
                }}
                >
                Submit
                </Button>

                {error && <Typography variant="body1" color="red">{error}</Typography>}
                {message && <Typography variant="body1" color="green">{message}</Typography>}


        </Box>
     )
  };


  const FAQItem = ({ question, answer }) => {
    const [open, setOpen] = useState(false);
  
    return (
      <Box
        sx={{
          border: '0.5px solid #FFFFFF',
          paddingY: 2,
          background:'linear-gradient(to bottom, #242424DB 0%, #151515 86%)',
          borderRadius:"16px",
          paddingInline:{
            xs:3,
            md:4,
            lg:4,
            xl:5
          }
        }}
        
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          onClick={() => setOpen(!open)}
          sx={{
            cursor: 'pointer',
            transition: '0.3s',
          }}
        >
          <Typography variant="body1" fontWeight={600} style={{color:'#A670FF',fontSize:"16px",textAlign:"left"}}>
            {question}
          </Typography>
          <IconButton
            onClick={() => setOpen(!open)}
            size='small'
            sx={{
              ml:2,
              width: 28,             // 👈 Make button smaller (default ~40px)
              height: 28,
              border:"3px solid #7D2DFF",
              color:"white",
              backgroundColor:"#A670FF",
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        </Box>
  
        <Collapse in={open} timeout="auto" unmountOnExit>
          <Box mt={1}>
            <Typography variant="body2" textAlign="left" style={{color:'#fff',fontSize:"14px",fontWeight:600,letterSpacing:"1%",lineHeight:'19px'}}>
              {answer}
            </Typography>
          </Box>
        </Collapse>
      </Box>
    );
  };


  const inputStyles = (error) => ({
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      border: error ? '1px solid red' : '1px solid #A670FF',
      color: '#fff',

      '& input': {
        color: '#fff',
        caretColor: '#fff',
      },

      '&:hover fieldset': {
        borderColor: error ? 'red' : '#A670FF',
      },
      '&.Mui-focused fieldset': {
        borderColor: error ? 'red' : '#A670FF',
        boxShadow: error
          ? '0 0 6px rgba(255,0,0,0.4)'
          : '0 0 8px rgba(166, 112, 255, 0.6)',
      },
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: error ? 'red' : '#A670FF',
    },
  });
  
  const BlurredBackground = ({top}) => {
    return(
        <Box
        sx={{
        // border:'2px solid blue',
        top,
        borderRadius: '50%',
        maxWidth:'261px',
        width: '80vh',
        height: '80vh',
        maxHeight:'261px',
        position: 'absolute',
        zIndex:0,
        // top: {top},
        background: `linear-gradient(
            to right,
            rgba(71, 224, 255) 0%,      
            rgba(106, 209, 233) 36%,
            rgba(146, 94, 255) 66%,
            rgba(124, 55, 228) 100%   
        )`,
        filter: 'blur(110px)',
        transform: 'translateZ(0)', 
        willChange: 'transform, filter',
        }}
        />
    )
  }



const CuratedProgram = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
      });

    // const [uri,setUri]=useState('');
    const uri = useContext(UriContext);
    
    

    const handleClick = (event) => {
        try {
           
          ReactGA.event({
            category: "download_clicks",
            action: "Download_CuratorProgram",
            label: 'CuratorProgram_download_button',
          });
      
        } catch (error) {
        //   console.error("error:", error);
        }
      };
    

    // useEffect(()=>{
    //     setUri(localStorage.getItem('url'));
    //   },[])
    
    const navigate = useNavigate();

    const curatorBenefits = [
        {
            title:"Impact",
            body:"Empower the community by recommending meaningful content."
        },
        {
            title:"Connection",
            body:"Network with fellow curators and connect with like minded people."
        },
        {
            title:"Visibility",
            body:"Your profile will be showcased to a wide and engaged community of Skoob."
        },
        {
            title:"Purpose",
            body:"Experience the joy of giving back by helping the community discover the right podcasts."
        },
    ]

    const faqData = [
        {
          question: 'How do I join the program?',
          answer: 'Simply sign up, fill out a short form to help us understand your interests, and we’ll guide you through everything you need to start recommending podcasts.'
        },
        {
          question: 'Is there any cost to join?',
          answer: 'No. Joining the Skoob Curator Program is completely free.'
        },
        {
          question: 'What kind of podcasts will I find on Skoob?',
          answer: 'Skoob offers daily AI-curated podcasts on topics like personal development, business, science, psychology, relationships, and productivity — perfect for learners, thinkers, and curious minds.'
        },
        {
            question: 'How do I recommend a podcast?',
            answer: 'Once onboarded, you’ll receive access to a form or an in-app feature where you can choose your favorite episodes and share why you think they matter.'
        },
        {
            question: 'Will I get recognition for my contribution?',
            answer: 'Yes. Outstanding curators will be featured on the Skoob platform, social media, and newsletters. We truly appreciate curators who give their best.'
        },
        {
            question: 'Can I suggest new ideas or topics for podcasts',
            answer: 'Simply sign up, fill out a short form to help us understand your interests, and we’ll guide you through everything you need to start recommending podcasts.'
        },
        {
            question: 'I still have questions. Who can I talk to?',
            answer: 'We’re here to help! Just drop us a message at Podcast@skoob.ai, and we’ll get back to you as soon as possible.'
        }

      ];


      const springProps = useSpring({
        from: { opacity: 0, transform: 'translateY(15%)' },
        to: async (next) => {
          await next({ opacity: 1, transform: 'translateY(0%)' });
        },
        config: { duration: 400 },
        immediate: !inView,
        reset: true,
      });
    

      const LeftWing = ({top,left='-20%'}) => {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    top,
                    left: {
                        xs:'-20%',
                        sm:'-18%',
                        md:'-17%',
                        lg:'-17%'
                    },
                    zIndex: 0, // or lower if it should be purely decorative
                    pointerEvents: 'none', // makes sure it doesn't block clicks
                }}
                >
                <img
                    src={leftWing}
                    alt="left wing"
                    style={{
                    maxWidth: '550px',
                    height: 'auto',
                    display: 'block',
                    }}
                />
            </Box>
        )
      };
    
      const RightWing = ({top,right='-30%'}) => {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    top,
                    right: {
                        xs:'-40%',
                        sm:'-25%',
                        md:'-26%',
                        lg:"-25%"
                    },
                    zIndex: 0, // or lower if it should be purely decorative
                    pointerEvents: 'none', // makes sure it doesn't block clicks
                }}
                >
                <img
                    src={rightWing}
                    alt="right wing"
                    style={{
                    maxWidth: '550px',
                    height: 'auto',
                    display: 'block',
                    }}
                />
            </Box>
        )
      };
    

    const CustomBox = styled(Box)(({ theme }) => ({
        display: 'flex',
        gap: theme.spacing(2),
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(1),
        backgroundColor: '#181819',
        textAlign:'center',
        zIndex:0,
        minHeight:'40vh',
        backgroundSize:'cover' ,
        // [theme.breakpoints.down('md')]: {
        //     flexDirection: 'column',
        //     alignItems: 'center',
        //     textAlign: 'center',
        // },
        '&::before': {
        content: '""', 
        position: 'absolute', 
        top: 0,
        left: 0,
        width: '100%',
        height: '68vh', 
        backgroundImage: `url(${starredBackground})`,
        backgroundSize: 'cover', 
        backgroundPosition: 'center', 
        zIndex: 2000, 
        pointerEvents: 'none',
    },
    }));



const GradientBorderCard = ({ children }) => {
    return (
      <Box
       sx={{
        width: '100%',
        position: 'relative',
        borderRadius: '16px',
        overflow: 'hidden', // clip to rounded edges
      
        // Top border
        '&::before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: '16px',
        padding: '1px', // thickness of border
        background: `
            linear-gradient(to bottom, #9137D2 0%, #A8C5FF 40%, #FBF5FF99 99%)`,
        WebkitMask:
            'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'destination-out',
        maskComposite: 'exclude',
        zIndex: 1,
        },
      
        // Bottom border
        '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            borderRadius: '16px',
            padding: '1px', // thickness of border
            background: `
                linear-gradient(to bottom, #9137D2 0%, #A8C5FF 40%, #FBF5FF99 99%)`,
            WebkitMask:
                'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
            WebkitMaskComposite: 'destination-out',
            maskComposite: 'exclude',
            zIndex: 1,
        },
      
        // Shared side styles
        '& .side-left, & .side-right': {
          content: '""',
          position: 'absolute',
          top: 0,
          width: '1px',
          height: '100%',
          background: 'linear-gradient(to bottom, #9137D2 0%, #A8C5FF 40%, #FBF5FF99 99%)',
          zIndex: 10,
        },
      
        // Left & Right placement
        '& .side-left': {
          left: 0,
          borderTopLeftRadius: '16px',
          borderBottomLeftRadius: '16px',
        },
        '& .side-right': {
          right: 0,
          borderTopRightRadius: '16px',
          borderBottomRightRadius: '16px',
        },
      }}
      >
        {/* Left and Right Borders */}
        <Box className="side-left" />
        <Box className="side-right" />
  
        {/* Actual Card */}
        <Card
          elevation={3} 
          width="100px"
          paddingY={3}
          sx={{
            height:{
                xs:"205px",
                sm:"200px",
            }
          }}
          style={{
           // backgroundColor:"black",
           background: 'linear-gradient(180deg, #151515 0%, #242424DB 86%)',
           
        //    border:"2px solid red",
           borderRadius:"16px",
           textAlign:"left",
          }}
        >
          {children}
        </Card>
      </Box>
    );
  };
  
  



    return (
        <Box
        id="CuratorProgram"
        ref={ref}
        >
            
            <CustomBox component='body'>
             {/* <animated.div style={{ ...springProps,}}> */}
                <Box style={{
                        position: 'relative',display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',
                        top:'0px',
                        right:0,
                        width:'100vw',
                        maxWidth:'600px'
                    }}
                    > 
                 
                 
                    <Box
                        style={{ marginLeft:0,display:"flex",flexDirection:"column",justifyContent:'center',alignItems:'center'}} 
                        sx={{zIndex:100}}
                        >
                            <Typography
                                variant='h1'
                                component='h1'
                                style={{
                            
                                    color: '#fff',
                                    fontFamily: 'Open Sans',
                                    fontWeight:'700',
                                    lineHeight:'36px',
                                    letterSpacing:'1%',
                                    // lineHeight:36,
                                    fontSize:'28px'
                                    
                                }}
                            >
                                You Love Podcasts
                            </Typography>
                            
                            <Typography
                                variant='p'
                                component='p'
                                style={{
                                    py: 0,
                                    marginTop:20,
                                    lineHeight: 1.8, 
                                    color: '#fff',
                                    fontSize: '14px',
                                    fontFamily: 'Open Sans',
                                    fontWeight: '500',
                                    width: '90vw'
                                }}
                            >
                            Help the skoob community to find the right one
                            </Typography>
                            
                    </Box>
                    
                    <Box marginTop={5} sx={{zIndex:100}}>
                        <img
                            src={beACurator}
                            alt="headerImg"
                            style={{
                                width:'90vw',
                                maxWidth:'550px'
                                // height:'258px'
                            }}
                        />
                    </Box>

                    <LeftWing top={{xs:'3%',sm:'3%',md:'4%'}}></LeftWing>


                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            zIndex: 100,
                        }}
                        >
                        <Box
                            sx={{
                            borderRadius: '42px',
                            display: 'flex',
                            padding:0,
                            justifyContent: 'center',
                            boxShadow: '0px 2px 10px -5px #FFFFFF',
                            alignItems: 'center',
                            position: 'relative',
                            backgroundColor: '#FFFFFF',
                            width: '70vw',
                            maxWidth: '213px',
                            height: '52px',
                            cursor: 'pointer',
                            }}
                        >
                            <ScrollLink
                            to="CuratorForm"
                            smooth={true}
                            duration={600}
                            offset={-100}
                            spy={true}
                            hashSpy={false}
                           
                            >
                            <Typography
                                sx={{
                                width: '70vw',
                                maxWidth: '213px',
                                paddingX: '24px',
                                paddingY: '14px',
                                fontFamily: 'Open Sans',
                                fontWeight: 600,
                                color: 'black',
                                fontSize: '14px',
                                lineHeight: '24px',
                                letterSpacing: '1%',
                                cursor: 'pointer',
                     
                                }}
                            >
                                Be a Curator
                            </Typography>
                            </ScrollLink>
                        </Box>
                        </Box>

                    
                    <BlurredBackground top={{ xs: '16%', sm: '17%', md: '18%' }}/>

                    <Box
                        marginTop={6}
                        paddingInline={5}
                        sx={{zIndex:100}}
                        style={{ marginLeft:0,display:"flex",flexDirection:"column",justifyContent:'center',alignItems:'center'}}
                        >
                            <Typography
                                variant='h3'
                                component='h3'
                                style={{
                            
                                    color: '#fff',
                                    fontFamily: 'Open Sans',
                                    fontWeight:'700',
                                    lineHeight:'36px',
                                    letterSpacing:'1%',
                                    width: '90vw',
                                    maxWidth:'300px',
                                    letterSpacing:'1%',
                                    // lineHeight:36,
                                    fontSize:'24px'
                                    
                                }}
                            >
                                About Skoob Curator Program
                            </Typography>
                            
                            <Typography
                                variant='p'
                                component='p'
                                style={{
                                    py: 0,
                                    marginTop:20,
                                    lineHeight: 1.8, 
                                    color: '#fff',
                                    fontSize: '14px',
                                    fontFamily: 'Open Sans',
                                    fontWeight: '500',
                                    width: '90vw',
                                    maxWidth:'500px',
                                    textAlign:'center',
                                    letterSpacing:'2%'
                                   
                                }}
                            >
                            At Skoob, we believe the right podcast at the right time can make a big difference in someone's life.
                             And so, we started the Skoob Curator Program—a community of podcast lovers who help others by sharing great episodes from the Skoob app.
                            </Typography>
                            
                    </Box>

                    <RightWing top={{xs:'16%',sm:'17%',md:'18%',lg:'19%'}} ></RightWing>

                    <Box marginTop={5} sx={{zIndex:100}}>
                        <img
                            src={PeopleListening}
                            alt="peoplelisteing"
                            style={{
                                width:'80vw',
                                maxWidth:'450px'
                                // height:'258px'
                            }}
                        />
                    </Box>

                   

                    <Box marginTop={5} paddingInline={6} sx={{zIndex:100}}>
                        <Typography
                            variant='h4'
                            component='h4'
                            style={{
                                color: '#fff',
                                fontFamily: 'Open Sans',
                                fontWeight:'700',
                                lineHeight:'25px',
                                letterSpacing:'1%',
                                width: '90vw',
                                maxWidth:'500px',
                                letterSpacing:'1%',
                                // lineHeight:36,
                                textAlign:'left'
                            }}
                            sx={{
                                fontSize:{
                                    xs:15,
                                    sm:16
                                }
                            }}
                        >
                            How You’ll Make an Impact as a Skoob Curator :
                        </Typography>
                    </Box>

                    <Box marginTop={1} style={{display:"flex",flexDirection:"column",gap:"15px"}} 
                      sx={{
                        width:"90vw",
                        maxWidth:"580px",
                        paddingInline:{
                            xs:0,
                            sm:5,
                            md:5,
                            lg:5
                        },
                        zIndex:100
                        }} 
                        
                    >
                       <Box style={{display:"flex",alignItems:"start",justifyContent:"start",}} 
                        
                       gap={1} 
                       >
                            <img
                                src={TickCircle}
                                alt="tick-circle"
                                style={{
                                    marginTop:"1px",
                                    width:'18px',
                                    // maxWidth:'450px'
                                    // height:'258px'
                                }}
                            />
                            <Typography
                                    variant='p'
                                    component='p'
                                    style={{
                                        color: '#fff',
                                        fontFamily: 'Open Sans',
                                        fontWeight:'600',
                                        lineHeight:'19px',
                                        letterSpacing:'1%',
                                        width: '90%',
                                        maxWidth:'500px',
                                        letterSpacing:'1%',
                                        fontSize:"14px",
                                        // lineHeight:36,
                                        textAlign:'left'
                                    }}
                                >
                                    Help someone who feels confused by too many podcast choices.
                            </Typography>
                        </Box>

                        <Box style={{display:"flex",alignItems:"start",justifyContent:"start",}} gap={1} width="90vw" maxWidth="580px" >
                            <img
                                src={TickCircle}
                                alt="tick-circle"
                                style={{
                                    width:'18px',
                                    marginTop:"1px",
                                    // maxWidth:'450px'
                                    // height:'258px'
                                }}
                            />
                            <Typography
                                    variant='p'
                                    component='p'
                                    style={{
                                        color: '#fff',
                                        fontFamily: 'Open Sans',
                                        fontWeight:'600',
                                        lineHeight:'19px',
                                        letterSpacing:'1%',
                                        width: '90%',
                                        maxWidth:'500px',
                                        letterSpacing:'1%',
                                        fontSize:"14px",
                                        // lineHeight:36,
                                        textAlign:'left',
                                        // border:"2px solid red"
                                    }}
                                >
                                    Just listen to a few, pick the ones you really like, and recommend them in your own words. 
                            </Typography>
                        </Box>

                        <Box style={{display:"flex",alignItems:"start",justifyContent:"start",}} gap={1} width="90vw" maxWidth="580px" >
                            <img
                                src={TickCircle}
                                alt="tick-circle"
                                style={{
                                    width:'18px',
                                    marginTop:"1px",
                                    // maxWidth:'450px'
                                    // height:'258px'
                                }}
                            />
                            <Typography
                                    variant='p'
                                    component='p'
                                    style={{
                                        color: '#fff',
                                        fontFamily: 'Open Sans',
                                        fontWeight:'600',
                                        lineHeight:'19px',
                                        letterSpacing:'1%',
                                        width: '90%',
                                        maxWidth:'500px',
                                        letterSpacing:'1%',
                                        fontSize:"14px",
                                        // lineHeight:36,
                                        textAlign:'left'
                                    }}
                                >
                                    Your suggestion could be exactly what someone needed to hear today.
                            </Typography>
                        </Box>
                    </Box>
                    
                    <LeftWing top={{xs:'35%',sm:'36%',md:'37%',lg:'39%'}}></LeftWing>

                    <Typography
                            variant='h4'
                            component='h4'
                            style={{
                                color: '#fff',
                                fontFamily: 'Open Sans',
                                fontWeight:'700',
                                lineHeight:'36px',
                                letterSpacing:'1%',
                                width: '90vw',
                                maxWidth:'500px',
                                letterSpacing:'1%',
                                fontSize:'24px',
                                textAlign:'center',
                                // lineHeight:36,
                                textAlign:'center'
                            }}
                    
                            marginTop={6}
                        >
                            Who Can Join?
                    </Typography>

                    <Box marginTop={5} zIndex={100}>
                        <img
                            src={HowCanJoin}
                            alt="headerImg"
                            style={{
                                width:'90vw',
                                maxWidth:'500px'
                                // height:'258px'
                            }}
                        />
                    </Box>

                    <BlurredBackground top={{ xs: '52%', sm: '54%', md: '58%' }}/>
                    
                    <RightWing top={{xs:'48%',sm:'49%',md:'52%',lg:'54%'}} ></RightWing>

                    <Typography
                            variant='h4'
                            component='h4'
                            zIndex={100}
                            style={{
                                color: '#fff',
                                fontFamily: 'Open Sans',
                                fontWeight:'700',
                                lineHeight:'36px',
                                letterSpacing:'1%',
                                width: '90vw',
                                maxWidth:'500px',
                                letterSpacing:'1%',
                                fontSize:'24px',
                                textAlign:'center',
                                // lineHeight:36,
                                textAlign:'center'
                            }}
                    
                            marginTop={8}
                            paddingInline={5}
                        >
                            What’s in It for You as a Curator
                    </Typography>

                    <Grid container spacing={3} width='90vw' maxWidth='580px' marginTop={3} 
                      sx={{zIndex:100,
                            paddingInline:{
                                xs:0,
                                sm:2,
                                lg:3
                            },
                            
                      }}
                    >
                        {curatorBenefits.map((item) => (
                            <Grid item xs={6} sm={6} key={item}> 
                                <GradientBorderCard>
                                    <CardContent>
                                        <Typography variant="h6" style={{color:"#A670FF",fontSize:"14px"}} 
                                         marginBottom={2}
                                         sx={{
                                            paddingInline:{
                                                xs:1,
                                                sm:3,
                                                lg:3
                                            },
                                            marginTop:{
                                                xs:1,
                                                sm:3,
                                                lg:3
                                            }
                                         }}
                                         >
                                            {item?.title}
                                         </Typography>
                                        <Typography variant="body2" style={{color:"white",fontSize:"14px"}} sx={{
                                            paddingInline:{
                                                xs:1,
                                                sm:3,
                                                lg:3
                                            }
                                         }}
                                         >
                                        {item?.body}
                                        </Typography>
                                    </CardContent>
                                </GradientBorderCard>
                            </Grid>
                        ))}
                    </Grid>


                    <Typography
                            variant='h4'
                            component='h4'
                            style={{
                                color: '#fff',
                                fontFamily: 'Open Sans',
                                fontWeight:'700',
                                lineHeight:'36px',
                                letterSpacing:'1%',
                                width: '90vw',
                                maxWidth:'500px',
                                letterSpacing:'1%',
                                fontSize:'24px',
                                textAlign:'center',
                                // lineHeight:36,
                                textAlign:'center'
                            }}
                    
                            marginTop={8}
                            paddingInline={5}
                        >
                            Join Skoob Curator Community
                    </Typography>

                <LeftWing top={{xs:'67%',sm:'70%',md:'71%',lg:'72%'}}></LeftWing>

                <CuratorForm />

                <BlurredBackground top={{ xs: '78%', sm: '80%', md: '82%' }}/>
                
                <RightWing top={{xs:'77%',sm:'78%',md:'79%',lg:'80%'}} right='-30%' ></RightWing>
          
                 <Typography
                            variant='h4'
                            component='h4'
                            zIndex={100}
                            style={{
                                color: '#fff',
                                fontFamily: 'Open Sans',
                                fontWeight:'700',
                                lineHeight:'36px',
                                letterSpacing:'1%',
                                width: '90vw',
                                maxWidth:'500px',
                                letterSpacing:'1%',
                                fontSize:'24px',
                                textAlign:'center',
                                // lineHeight:36,
                                textAlign:'center'
                            }}
                    
                            marginTop={7}
                            paddingInline={5}
                        >
                            Frequently Asked Questions
                    </Typography>


                    <Box sx={{zIndex:100, maxWidth: '580px',width:'90vw', mx: 'auto', mt: 4,display:"flex",flexDirection:"column",gap:"15px",paddingInline:{xs:0,sm:2,md:3,lg:4} ,zIndex:100}}>
                        {faqData.map((item, index) => (
                            <FAQItem key={index} question={item.question} answer={item.answer} />
                        ))}
                    </Box>

                  <Box marginBottom={8}>

                  </Box>
                    

                </Box>

                {/* </animated.div>   */}
            </CustomBox>
        </Box >
    )
}

export default CuratedProgram